"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AdvancedModal = _interopRequireDefault(require("../../AdvancedModal"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _InputSelect = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputSelect"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class MapWidgetManagerSelector extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      mapOptions: _OctaviParameters.default.mapOptions
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.selectedMapWidgetChoices = [{
      value: "originMap"
    }, {
      value: "destinationMap"
    }];
    this.selectedMapStyleChoices = [{
      value: "SRMap"
    }, {
      value: "SMMap"
    }];
    this.selectedObjectChoices = [{
      value: "driver"
    }, {
      value: "vehicles"
    }, {
      value: "operators"
    }, {
      value: "activities"
    }, {
      value: "distance"
    }, {
      value: "duration"
    }];
    this.temporalOptionChoices = [{
      value: "byMonth"
    }, {
      value: "byWeek"
    }, {
      value: "byDay"
    }, {
      value: "none"
    }];
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on("taxi.filter.manageMapWidget.request", this.handleOpen);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off("taxi.filter.manageMapWidget.request", this.handleOpen);
  }
  handleOpen() {
    this.setState({
      isActive: true,
      selected: {}
    });
  }
  handleClose() {
    this.setState({
      isActive: false,
      selected: {}
    });
  }
  handleConfirm() {
    _OctaviParameters.default.mapOptions = this.state.mapOptions;
    _ServiceLocator.default.eventManager.emit('taxi.filter.selectedMapOptions.update', this.state.mapOptions);
  }
  onValueChange(e, optionName) {
    const newSelectedOption = e.target.value;
    const newOptions = _objectSpread({}, this.state.mapOptions);
    newOptions[optionName] = newSelectedOption;
    this.setState({
      mapOptions: newOptions
    });
  }
  renderContainer() {
    const objectChoisesList = ["operators", "driver", "vehicles", "activities", "none"];
    if (objectChoisesList.includes(this.state.mapOptions.selectedMapObject)) {
      objectChoisesList.splice(objectChoisesList.indexOf(this.state.mapOptions.selectedMapObject), 1);
    }
    const objecChoises = objectChoisesList.map(function (choice) {
      return {
        value: choice
      };
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:mapObject:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.selectedObjectChoices,
      t: this.props.t,
      value: this.state.mapOptions.selectedMapObject ? this.state.mapOptions.selectedMapObject : "none",
      localePrefix: "octavi:widgetOptions:mapObject",
      onValueChange: e => this.onValueChange(e, "selectedMapObject"),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:tripPart:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.selectedMapWidgetChoices,
      t: this.props.t,
      value: this.state.mapOptions.selectedMapWidget ? this.state.mapOptions.selectedMapWidget : "none",
      localePrefix: "octavi:widgetOptions:tripPart",
      onValueChange: e => this.onValueChange(e, "selectedMapWidget"),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:mapStyle:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.selectedMapStyleChoices,
      t: this.props.t,
      value: this.state.mapOptions.selectedMapStyle ? this.state.mapOptions.selectedMapStyle : "none",
      localePrefix: "octavi:widgetOptions:mapStyle",
      onValueChange: e => this.onValueChange(e, "selectedMapStyle"),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:temporalOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.temporalOptionChoices,
      t: this.props.t,
      value: this.state.mapOptions.temporalOption ? this.state.mapOptions.temporalOption : "none",
      localePrefix: "octavi:widgetOptions:temporalOption",
      onValueChange: e => this.onValueChange(e, "temporalOption"),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:objectOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: objecChoises,
      t: this.props.t,
      value: this.state.mapOptions.objectOption ? this.state.mapOptions.objectOption : "none",
      localePrefix: "octavi:widgetOptions:objectOption",
      onValueChange: e => this.onValueChange(e, "objectOption"),
      noBlank: true
    }))));
  }
  render() {
    const {
      isActive,
      selected
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_AdvancedModal.default, {
      title: this.props.t('octavi:widgetOptions:mapTitle'),
      t: this.props.t,
      isOpen: isActive,
      container: this.renderContainer(),
      showCancelButton: true,
      showConfirmButton: true,
      closeModal: this.handleClose,
      confirmAction: this.handleConfirm,
      isConfirmButtonDisabled: false
    });
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(MapWidgetManagerSelector);
MapWidgetManagerSelector.propTypes = {
  activeSection: _propTypes.default.string
};